export default __webpack_public_path__ + "static/media/830.741cc609.png";